<template>
  <div class="referenceAnswer">
    <div class="top-list">
      <span
        >{{ detailData.questionOrder }}、{{ detailData.questionTypeName }}</span
      >
      <span>{{ detailData.difficulty | setName(difficultyList) }}</span>
      <span>{{ detailData.questionScore }}分</span>
    </div>
    <div class="question-box" v-html="detailData.questionContent"></div>
    <div class="awswer-box">
      <p class="title">参考答案</p>
      <div v-html="detailData.questionAnswer"></div>
      <p class="title">试题解析</p>
      <div v-html="detailData.analysis"></div>
    </div>
  </div>
</template>

<script>
import { getquestionanswer, getcorrectdetails } from "@/api/interface";
import { difficultyList } from "@/util/constdata";
export default {
  name: "ReferenceAnswer",
  data() {
    return {
      difficultyList: difficultyList,
      detailData: {},
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        // console.log(this.$route.query)
        this.loadView();
      },
    },
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    this.loadView();
  },
  updated() {
    window.MathJax.startup.defaultReady();
  },
  methods: {
    loadView() {
      let type = this.$route.query.isWeb;
      if (type) {
        if (this.$route.query.token) {
          this.$store.commit("setToken", this.$route.query.token);
          this.$store.commit("setSchoolId", this.$route.query.schoolID);
        }
        this.init();
      } else {
        if (this.$route.query.token && this.$route.query.schoolID) {
          this.$store.commit("setToken", this.$route.query.token);
          this.$store.commit("setSchoolId", this.$route.query.schoolID);
          this.init();
        } else {
          window.initView = this.initView;
          this.initMobile();
        }
      }
      window.MathJax.typesetPromise();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    getPhoneType() {
      let u = navigator.userAgent;
      this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", data.token);
      this.$store.commit("setSchoolId", data.schoolID);
      this.init();
      // this.downWindow();
    },
    init() {
      let data = {
        id: this.$route.query.questionId,
        questionOrder: this.$route.query.questionOrder,
      };
      if (this.$route.query.studentID) {
        data.studentId = this.$route.query.studentID;
        getcorrectdetails(data).then((res) => {
          this.detailData = res.data;
        });
      } else {
        getquestionanswer(data).then((res) => {
          this.detailData = res.data;
          // console.log(res);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.referenceAnswer {
  .top-list {
    padding: 10px 20px;
    span {
      margin-right: 12px;
    }
  }
  img {
    max-width: 100%;
    height: auto !important;
  }
  .awswer-box {
    border-top: 12px solid rgba(248, 248, 248, 100);
    padding: 15px 20px;
    > div {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }
  }
  .title {
    position: relative;
    padding-left: 10px;
    margin-bottom: 6px;
    height: 20px;
    line-height: 20px;
    &::after {
      left: 0;
      top: 0;
      position: absolute;
      width: 3px;
      height: 100%;
      background-color: rgba(123, 156, 199, 100);
      content: "";
    }
  }
}
</style>
